"use strict";

const m = require("mithril");

const strings = require("./strings.csv");

const css = require("./footer.css");

module.exports = {
    view({ attrs }) {
        const i18n = strings[attrs.lang].footer.esrb[attrs.gameCode];

        return m("div",
            {
                class       : css.rating,
                "data-test" : "esrb-rating"
            },
            m("a", {
                    class  : css.esrb,
                    href   : "https://www.esrb.org",
                    target : "_blank"
                },
                "ESRB Teen"
            ),
            m("div",
                m("ul",
                    i18n.upper.split(",").map((line) => m("li", line.trim()))
                ),
                i18n.lower && [
                    m("hr"),
                    m("ul",
                        i18n.lower.split(",").map((line) => m("li", line.trim()))
                    )
                ]
            )
        );
    }
};
